'use client';

import React from 'react';
import SearchContent from '@/containers/search/SearchContent';
import { Dialog } from '@skin-seoul/design-system';
import { CLASSNAME } from '@skin-seoul/service';
type FiboSearchModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onExit?: () => void;
};
export const FiboSearchModal = ({
  isOpen,
  onClose,
  onExit
}: FiboSearchModalProps) => {
  return <Dialog.Root motionPreset="none" onExitComplete={onExit} unmountOnExit size="full" open={isOpen} onOpenChange={onClose} data-sentry-element="Dialog.Root" data-sentry-component="FiboSearchModal" data-sentry-source-file="FiboSearchModal.tsx">
      <Dialog.Positioner zIndex="skipNav" data-sentry-element="Dialog.Positioner" data-sentry-source-file="FiboSearchModal.tsx">
        <Dialog.Content className={CLASSNAME.NOT_TRANSLATE} data-sentry-element="Dialog.Content" data-sentry-source-file="FiboSearchModal.tsx">
          <SearchContent onBack={onClose} data-sentry-element="SearchContent" data-sentry-source-file="FiboSearchModal.tsx" />
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>;
};